import React from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input
} from "reactstrap";
import logo from '../asist.png'
import axios from 'axios'
import ChevronArrows from "./ui_commons/chevronArrows";

export default class NavBar extends React.Component {
  constructor(props) {
    super(props);
    window.addEventListener('click', (e) => {
      if (!document.getElementById('clickBox') || !document.getElementById('clickBox').contains(e.target)) {
        this.setState({
          isOpen: false
        });
      }
    });

    window.addEventListener('resize', (event) => {
      this.setState({
        isOpen: false
      });
      if (event.target.innerWidth > 768) {
        this.setState({ isDroppedDown: true })
      } else {
        this.setState({ isDroppedDown: false })
      }
    }, true);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      toggleOpen: false,
      isDroppedDown: false
    };
  }

  componentDidMount() {
    if (window.innerWidth > 768) {
      this.setState({ isDroppedDown: true })
    } else {
      this.setState({ isDroppedDown: false })
    }
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  showForm() {
    this.props.showForm();
  }

  signOut = async () => {
    console.log('signOut')
    await axios.get('/logout')
      .then(() => {
        window.location = "/login";
      })
  }

  toggleMenu = () => {
    this.setState({
      toggleOpen: !this.state.toggleOpen
    }, () => { console.log(this.state.toggleOpen) });

  }
  // #707d8b
  render() {
    return (
      <div style={{ zIndex: "3000", position: "absolute", width: "100%" }}>
        <Navbar color="dark" dark expand="md" id='clickBox'>
          {/* <NavbarBrand href="/"><img width="75" height="25" alt='Logo' src={logo}></img></NavbarBrand> */}
          <NavbarBrand href="/"><h1 style={{ margin: "auto", fontSize: "1.4rem" }}><b>GMAPP</b></h1></NavbarBrand>
          <NavbarToggler onClick={this.toggle} />

          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink href="#" onClick={() => this.showForm()} className='mainNavItem'>
                  {this.state.isDroppedDown ?
                    <i className="fa fa-plus" aria-hidden="true"></i>
                    : <span style={{ color: "white" }}>Add Asset</span>
                  }
                </NavLink>
                {/* Add */}
              </NavItem>
              <UncontrolledDropdown nav inNavbar toggle={() => this.toggleMenu()} isOpen={this.state.toggleOpen} className='mainNavDropdownLink'>
                <DropdownToggle nav>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    Services
                    {/* {this.state.isDroppedDown ? <ChevronArrows direction={!this.state.toggleOpen ? "down" : "up"} /> : null} */}
                  </div>
                </DropdownToggle>
                <DropdownMenu end style={{ left: "-40px" }}>
                  {/* <DropdownItem> */}
                  <div className="dropDownCheck">
                    <img alt="hydrant" src={require('../fire-hydrant.png')} width='20' height='20'></img>
                    <span>Hydrants</span>
                    <label className="checkContainer">
                      <input type="checkbox" checked="checked" />
                      <span className="checkmark"></span>
                    </label>
                    {/* FireHydrants */}
                  </div>
                  {/* </DropdownItem>
                  <DropdownItem> */}
                  <div className="dropDownCheck">
                    <img alt="Sewers" src={require('../manhole.png')} width='20' height='20'></img>
                    <span>Sewers</span>
                    <label className="checkContainer">
                      <input type="checkbox" disabled />
                      <span className="checkmark"></span>
                    </label>
                    {/* <Input
                      addon
                      style={{ width: "22px" }}
                      aria-label="Sewers"
                      type="checkbox"
                      disabled
                    /> */}

                  </div>
                  {/* </DropdownItem> */}
                  <DropdownItem divider />
                  <DropdownItem>Contact Us</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <NavLink href="/account" className='mainNavItem'>
                <span style={{ color: "white" }}>Account</span>
              </NavLink>
              <NavLink href="#" onClick={() => this.signOut()} className='mainNavItem'>
                <span style={{ color: "white" }}>Sign Out</span>
              </NavLink>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavBar.jsx